<div fxLayout="row" fxLayoutAlign="center center" class="login" fxFlex="100">
  <span fxFlex.gt-sm="30" fxFlex.lt-md="5"></span>
  <app-login-form (onLogin)="login($event)" fxFlex.gt-sm="40" fxFlex.lt-md="90"></app-login-form>
  <span fxFlex.gt-sm="30" fxFlex.lt-md="5"></span>
</div>
